import { ErrorBoundary } from 'react-error-boundary'

import { HistoryContainer } from '../features/history/deliveryforecasts/components'
import FallbackErrorMessage from '../utils/errors/FallbackMessage'

export const DeliveryForecastsHistoryPage: React.FC = () => {
  return (
    <ErrorBoundary FallbackComponent={FallbackErrorMessage}>
      <HistoryContainer />
    </ErrorBoundary>
  )
}
